import { PageEvent } from '@angular/material/paginator';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MgService } from 'src/app/services/mg.service';
import { BasicRegister } from "../../../models/basic-register.model";
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Pagination } from 'src/app/models/pagination.model';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


@Component({
  selector: 'app-list-business',
  templateUrl: './list-business.component.html',
  styleUrls: ['./list-business.component.scss']
})
export class ListBusinessComponent implements OnInit {
  public callForm: UntypedFormGroup;
  public items: BasicRegister[];
  public displayedColumns: string[] = ['id', 'name', 'cnpj', 'users', 'calls'];
  public _loading: boolean = false;

  public page: Pagination;
  public pageSize = 0;
  public length = 0;
  public pageSizeOptions: number[] = [1, 5, 8, 10, 25, 100, 200, 300];
  public pageEvent: PageEvent;

  public searchControl = new UntypedFormControl;

  constructor(
    public api: MgService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.listAllBusinessPag();
    this.searchControl.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
      )
      .subscribe(
        res => {
          this.listAllBusinessPag(res);
        }
      )
  };

  public set setPage(page: PageEvent) {
    this.pageEvent = page;
    this.listAllBusinessPag(this.searchControl.value, page.pageIndex + 1, page.pageSize);
  }

  private listAllBusinessPag(search: string = '', page: number = 1, perPage: number = 8): void {
    this._loading = true;
    search = search == null ? '' : search;
    this.api.listAllBusiness(search, page, perPage)
      .subscribe(
        res => {
          this.page = res;
          this.items = this.page.data;
          this.length = this.page.meta.total;
          this.pageSize = this.page.meta.per_page;
          this._loading = false;
        },
        err => {
          console.error(err);
          this._loading = false;
        }
      )
  }


  public goToAddBusiness(): void {
    this.router.navigate(['/operador/empresas/adicionar'])
  };

  public listBusinessUsers(business: number){
    this.router.navigateByUrl(`/operador/usuarios/empresa/${business}`)
  }

  public listBusinessCalls(business: number){
    this.router.navigateByUrl(`/operador/chamados?businesses=${business}`)
  }
}
